import { Formik, Form } from "formik";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { Icon } from "@mui/material";

import { useMutation } from "@tanstack/react-query";
import MDTypography from "components/MDTypography";
import { useState } from "react";

import { uploadConsignee } from "services/data.internal.service";
import { useCustomerValue } from "providers/CustomerContext";
import { InboundLayout, InboundHeaderCard } from "ui-components/Layout";
import { StripedDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import { Success, Error, LoadingDialog } from "ui-components/Alert";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";

function UploadConsignee() {
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [uploadResps, setUploadResps] = useState([]);
  const uploadConsigneeMutation = useMutation(uploadConsignee, {});
  const uploadStatus = uploadConsigneeMutation.status === "loading";
  const { downloadCsv, isDownloading } = useCsvDownloadHook();

  const handleSubmit = (values, actions) => {
    let formData = new FormData();
    formData.append("files", values.files[0], values.files[0].name);
    formData.append("customerCode", customerCode);

    uploadConsigneeMutation.mutate(formData, {
      onSuccess: (data) => {
        document.getElementById("files").value = null;
        setUploadResps(data.data.data);
      },
      onError: (data) => {
        setAlert(<Error data={data} onChange={setAlert} />);
      },
    });
    actions.setSubmitting(false);
  };

  const handleDownload = () => {
    window.open("/api/template/gettemplate?type=consignee");
  };

  return (
    <InboundLayout lg={12}>
      {alert}
      {isDownloading && <ExportDialog />}
      {uploadStatus && <LoadingDialog />}
      <InboundHeaderCard>
        <MDBox>
          <MDBox pb={1}>
            <MDTypography color="info" variant="h3">
              Upload Consignee
            </MDTypography>
            <MDTypography color="default" variant="h3">
              Selected Customer: {customerCode}
            </MDTypography>
          </MDBox>
          <MDButton variant="gradient" color="info" onClick={handleDownload}>
            Download Template
          </MDButton>

          <Formik initialValues={{ files: [] }} onSubmit={handleSubmit}>
            {({ values, isSubmitting, setFieldValue }) => (
              <Form>
                <MDBox mt={2}>
                  <input
                    type="file"
                    name="files"
                    id="files"
                    onChange={(e) => {
                      setFieldValue("files", e.target.files);
                      setUploadResps([]);
                    }}
                  />
                </MDBox>

                <MDBox mt={2} display="flex" justifyContent="center">
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="info"
                    disabled={!values.files.length > 0 || isSubmitting}
                  >
                    {isSubmitting ? "Uploading" : "Upload"}
                  </MDButton>
                </MDBox>
              </Form>
            )}
          </Formik>
        </MDBox>
      </InboundHeaderCard>

      {uploadResps.length > 0 && (
        <InboundHeaderCard>
          <MDBox p={3}>
            <MDBox pb={1}>
              <MDTypography sx={{ marginBottom: ".5rem" }} color="info" variant="h4">
                Upload Response{" "}
                {/* <MDButton type="submit" variant="gradient" color="info">
                  <Icon>download</Icon>&nbsp;
                  <CSVLink
                    style={{ color: "white" }}
                    headers={[
                      {
                        label: "Consignee Code",
                        key: "consigneeCode",
                      },
                      {
                        label: "Message",
                        key: "message",
                      },
                    ]}
                    filename={"upload_consignee_" + dayjs(new Date()).format("DD-MM-YYYY")}
                    data={uploadResps.filter((x) => !x.success)}
                  >
                    Export
                  </CSVLink>
                </MDButton> */}
                <MDButton
                  type="submit" variant="gradient" color="info"
                  onClick={() => {
                    const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_UploadConsignee`;
                    const headers = [
                      {
                        label: "Consignee Code",
                        key: "consigneeCode",
                      },
                      {
                        label: "Message",
                        key: "message",
                      },
                    ]
                    downloadCsv(filename, uploadResps.filter((x) => !x.success), headers)
                  }}
                >
                  <Icon>download</Icon>&nbsp;
                  export
                </MDButton>
              </MDTypography>
              <StripedDataGrid
                columns={[
                  {
                    headerName: "Status",
                    field: "success",
                    align: "center",
                    renderCell: (cell) =>
                      cell.row.success ? (
                        <StatusIcon color="success" icon="done" />
                      ) : (
                        <StatusIcon color="error" icon="close" />
                      ),
                  },
                  { headerName: "Consignee Code", field: "consigneeCode", width: 200 },
                  {
                    headerName: "Message",
                    field: "message",
                    flex: 1,
                    wordWrapEnabled: true,
                    renderCell: (cell) => (
                      <div>
                        {cell.row.message.map((c, i) => (
                          <p key={i}>{c}</p>
                        ))}
                      </div>
                    ),
                  },
                ]}
                rows={uploadResps}
                getRowHeight={(cell) => {
                  if (cell.model.message.length > 2) {
                    return "auto";
                  } else {
                    return 50;
                  }
                }}
              />
            </MDBox>
          </MDBox>
        </InboundHeaderCard>
      )}
    </InboundLayout>
  );
}

const StatusIcon = ({ color, icon }) => (
  <MDButton color={color} variant="outlined" size="small" iconOnly circular>
    <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
  </MDButton>
);

export default UploadConsignee;
